// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".star_wrap[data-v-4876b1df]{position:fixed;top:50%;left:50%;width:220px;height:220px;transform:translate(-50%,-50%);z-index:9999}", ""]);
// Exports
module.exports = exports;
